import * as React from "react";
import { cn } from "@/lib/utils";

const buttonVariants = {
  default: "bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2",
  secondary: "bg-slate-100 text-slate-900 hover:bg-slate-200 focus:ring-2 focus:ring-slate-400 focus:ring-offset-2",
  outline: "border border-slate-300 bg-transparent hover:bg-slate-50 text-slate-700 focus:ring-2 focus:ring-slate-400 focus:ring-offset-2",
  ghost: "bg-transparent hover:bg-slate-100 text-slate-700 focus:ring-2 focus:ring-slate-400 focus:ring-offset-2",
  destructive: "bg-red-600 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2",
};

const buttonSizes = {
  sm: "px-4 py-2 text-sm",
  md: "px-6 py-2.5 text-base",
  lg: "px-8 py-3 text-lg",
};

export const Button = React.forwardRef(
  ({ className, variant = "default", size = "md", disabled, ...props }, ref) => {
    return (
      <button
        className={cn(
          "inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "hover:scale-[1.02] active:scale-[0.98]",
          buttonVariants[variant],
          buttonSizes[size],
          className
        )}
        ref={ref}
        disabled={disabled}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";
